import React, {Component} from 'react'
import {LIMIT} from "../helpers/filtersTable"
import {Select} from "antd"
import 'antd/lib/select/style/index.css'
import PropTypes from "prop-types"

const {Option} = Select

class OrdersReportTotal extends Component {
    _handleChangeLimit = (value) => {
        const {onChangeLimit} = this.props

        onChangeLimit(value)
    }

    render() {
        const {limit, total} = this.props

        return (
            <div className='d-flex align-items-center justify-content-end'>
                <div className='d-flex align-items-center ml-3'>
                    <div>Hiển thị</div>
                    <Select
                        style={{width: 100}}
                        showArrow={true}
                        defaultValue={limit}
                        className="ml-1"
                        onChange={this._handleChangeLimit}
                        value={limit}
                    >
                        {
                            LIMIT.map(item => {
                                return <Option key={item.value} value={item.value}>{item.name}</Option>
                            })
                        }
                    </Select>

                    <div className='ml-3'>Tổng số: <span className='font-weight-bold'>{total || 0}</span> orders</div>
                </div>
            </div>
        )
    }
}

OrdersReportTotal.propTypes = {
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    onChangeLimit: PropTypes.func.isRequired
}

export default OrdersReportTotal